import { z } from 'zod'
import { FlightScheduleType } from '@library/enums/flight-schedule-type'
import { CourtesyStatus } from '~library/enums'
import { managerBenefitCommonSchema } from '~library/models'

export const assignBenefitsGetListSchema = z
  .object({
    /** 指派禮遇id */
    id: z.string(),
    /** 禮遇商品id */
    commodityId: z.string(),
    /** 數量 */
    quantity: z.number(),
    /**
     * 狀態
     * -  N:未指派
     * -  A:已指派
     * -  W:歸還
     * -  E:過期
     * -  V:核銷
     * -  S:部分核銷
     * -  P:申請中
     * -  R:作業中
     * -  B:重新指派
     * -  U:已綁定行程
     * -  X:作廢
     * -  L:客服處理中
     */
    status: z.nativeEnum(CourtesyStatus),
    /** 使用起始時間 */
    useStartTime: z.string(),
    /** 使用截止時間 */
    useEndTime: z.string(),
    /** 使用說明與注意事項PDF檔案Id[英文] */
    englishDescFileId: z.string(),
    /** 使用說明與注意事項PDF檔案Id[簡體中文] */
    simplifiedDescFileId: z.string(),
    /** 使用說明與注意事項PDF檔案Id[繁體中文] */
    traditionalDescFileId: z.string(),
    /** 會員卡號 */
    memberCardNumber: z.string(),
    /** 指派 */
    assign: z.boolean(),
    /** 歸還 */
    return: z.boolean(),
    /** 收回 */
    restore: z.boolean(),
    /** 安排類型 */
    flightScheduleType: z.nativeEnum(FlightScheduleType)
  })
  .merge(managerBenefitCommonSchema)

export interface AssignBenefitsGetList
  extends z.infer<typeof assignBenefitsGetListSchema> {}
